import { Injectable } from '@angular/core';
import { getQueryParams } from '@pin-up-global/common';
import { ApiService } from '@shared/abstraction';
import { manageLoadingStatus } from '@shared/rxjs-operators';
import { Observable } from 'rxjs';
import {
  AnalyticReq,
  AuthorizedUsersCountSchema,
  BarChartSchema,
} from './analytics.abstraction';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsApiService extends ApiService {
  isLoading$ = this._isLoading$;

  readonly #apiController: string = '@api/statistics/user-events';

  getUsersCount(params: AnalyticReq): Observable<AuthorizedUsersCountSchema> {
    return this._httpClient
      .get<AuthorizedUsersCountSchema>(
        `${this.#apiController}/authorized-users/count/`,
        { params: getQueryParams(params) }
      )
      .pipe(manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$));
  }

  getChartCount(params: AnalyticReq): Observable<BarChartSchema> {
    return this._httpClient
      .get<BarChartSchema>(`${this.#apiController}/grouped-by-type/chart/`, {
        params: getQueryParams(params),
      })
      .pipe(manageLoadingStatus(this._isLoadingMap, this._isLoadingMap$));
  }
}
